import {getLocalizationBasedOnLang} from '../../../data/models/User/UserInfo';

const english = {
  deny: 'Ignore',
  notifications: 'Notifications',
  viewAll: 'View all notifications',
  noNotifications: 'No new notifications',
  viewCourse: 'View course',
  markAsRead: 'Delete',
  viewWorkspace: 'View workspace',
  newNotifications: 'Recent notifications',
  seenNotifications: 'Seen notifications',
};

const welsh = {
  deny: 'Anwybyddu',
  notifications: 'Hysbysiadau',
  viewAll: 'Gwedl pawb',
  noNotifications: 'Dim hysbysiadau n4ewydd',
  markAsRead: 'Dileu',
  viewCourse: 'Gweld y cwrs',
  viewWorkspace: 'Gweld y gweithle',
};

export const notificationsText: any = getLocalizationBasedOnLang(
  english,
  welsh,
);
